import {useDispatch, useSelector} from "react-redux";
import users from "../../../users";
import {useState} from "react";
import cap17drive from "../../index";
import {toast} from "react-toastify";
import {markAsViewLater} from "../../../../utils/TorresowoBackend";
import auth from "../../../../utils/authentication";
import {useIntl} from "react-intl";
import ButtonV2 from "../../../shared/button-v2/button-v2";

const TmdbViewLater = ({tmdbItem}) => {
    const darkMode = useSelector(users.selectors.isDarkMode);
    const dispatch = useDispatch();
    const intl = useIntl();
    const [loading, setLoading] = useState(false);

    function markThingToViewLater(thing, view_later) {
        return markAsViewLater({
            uid: auth.currentUser.uid,
            tmdbId: thing.id,
            season_number: thing.isMovie ? -1 : 1,
            episode_number: thing.isMovie ? -1 : 1,
            view_later
        });
    }

    if (!tmdbItem) {
        return null;
    }

    const handleViewLater = (e) => {
        setLoading(true);
        markThingToViewLater(tmdbItem, !tmdbItem.view_later).then(() => {
            if (tmdbItem.view_later) {
                toast("Se ha eliminado de la lista de ver más tarde", {type: "error"});
            } else {
                toast("Se ha añadido a la lista de ver más tarde", {type: "info"});
            }
            if (tmdbItem.isMovie) {
                dispatch(cap17drive.actions.updateSelectedEpisode({...tmdbItem, view_later: !tmdbItem.view_later}));
            } else {
                dispatch(cap17drive.actions.updateSelectedSerie({...tmdbItem, view_later: !tmdbItem.view_later}));
            }
        }).finally(() => {
            setLoading(false);
        });
    }
    return (
        <ButtonV2
            width="50px"
            disabled={loading}
            active={tmdbItem.view_later}
            title={intl.formatMessage({id: tmdbItem.view_later ? "tmdb-view-later.button.remove-title" : "tmdb-view-later.button.title"})}
            onClick={handleViewLater}>
            {!loading && <i className="fa-solid fa-clock-rotate-left fa-flip-horizontal fa-lg"></i>}
            {loading && <i className="fa-solid fa-spinner fa-spin fa-lg"></i>}
        </ButtonV2>
    )

}

export default TmdbViewLater;
